// src/api/alreadySelectedProductApi.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/helpers/axiosInstance';

export const fetchAlreadySelectedProductIds = createAsyncThunk(
  'alreadySelectedProducts/fetchByInteractionId',
  async (interactionId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `/selected-structures/get-all-used-selected-structure-ids/${interactionId}`
      );
      return response.data.data?.ids; // Assuming this returns an array of product IDs
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch selected products'
      );
    }
  }
);

